import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';

const BreakoutTile = (props) => {
  const {
    title,
    time,
    topic,
    panelists,
    speakers,
    extraInfo,
    buttonImage,
    buttonColor,
  } = props;

  return (
  // <div className="tile__exhibition" style={{ borderColor: buttonColor }} >
  //   <div className="tile-holder" style={{ color: buttonColor }}>
  //     <div className="title" style={{ color: buttonColor }}>
  //       <span>{title}</span>
  //     </div>
  // className="session__tile">
    <Link to={`/main/breakout-sessions/class/${time}`} className="session">
      <img className="company__image" alt="user" src={buttonImage} />
      <div className="content">
        <div className="time"><FontAwesomeIcon icon={['fas', 'clock']} /> {time}</div>
        <span>{title}</span>
        <div className="sub__copy">
          <div className="topic__copy">{topic}</div>
          {panelists !== '' ? <div className="panelists__copy"><b>Panelists: </b>{panelists}</div> : undefined}
          {speakers !== '' ? <div className="speakers__copy"><b>Speakers: </b>{speakers}</div> : undefined}
          {extraInfo !== '' ? <div className="extra__copy">{extraInfo}</div> : undefined}
        </div>
        {/* <div className="panelists__copy">{panelists}</div>
        <div className="speakers__copy">{speakers}</div>
        <div className="extra__copy">{extraInfo}</div> */}
        <div className="sub__btn">
          Join Now &gt;
        </div>
      </div>
    </Link>
  // </div>
  );
};

BreakoutTile.propTypes = {
  title: PropTypes.string,
  time: PropTypes.string,
  buttonImage: PropTypes.string,
  topic: PropTypes.string,
  buttonColor: PropTypes.string,
  panelists: PropTypes.string,
  speakers: PropTypes.string,
  extraInfo: PropTypes.string,
};

BreakoutTile.defaultProps = {
  title: '',
  time: '',
  buttonImage: '',
  topic: '',
  buttonColor: '',
  panelists: '',
  speakers: '',
  extraInfo: '',
};

export default BreakoutTile;
